const container=[{initial:"empty record"}]
const defermentr=(state=container,action)=>{

// console.log("payload 2",action.payload)
  switch(action.type){

 case'DEFERMENT':
 return {record:action.payload}

 default:
   return state;

  }
}


export default defermentr;